import { signal, computed } from "@angular/core";
import { MachineStatesEnum } from "../enums/machine-states.enum";
import { MachineMeasurementsValueDto } from "./machine-measurements-value.dto";
import { ProductionOrderProcessDto } from "./production-order-process.dto";
import { SensorDto } from "./sensor.dto";

export class MachineDto {
    id!: number;
    name!: string;
    ip!: string;
    machineMeasurementsValues?: MachineMeasurementsValueDto[];
    createdAt?: Date;
    updatedAt?: Date;
    createdBy!: number;
    updatedBy!: number;
    queueName?: string;
    state!: MachineStatesEnum;
    sensors?: SensorDto[];
}

export class MachineDashboardDto {
    id!: number;
    name!: string;
    ip!: string;
    machineMeasurementsValues?: MachineMeasurementsValueDto[];
    createdAt?: Date;
    updatedAt?: Date;
    createdBy!: number;
    updatedBy!: number;
    queueName?: string;
    state!: MachineStatesEnum;
    productionOrderProcesses!: ProductionOrderProcessDto[];
    machineSignals?: MachineSignals;
    sensors?: SensorDto[];
}

type MachineSignals = {
    quantityToProduce: ReturnType<typeof signal<number>>;
    multiplier: ReturnType<typeof signal<number>>;
    quantityProduced: ReturnType<typeof signal<number>>;
    velocity: ReturnType<typeof signal<number>>;
    estimatedTime: ReturnType<typeof computed>;
};
